import React, { Component } from 'react'
import PropTypes from 'prop-types'

import PreviewBaneer from './preview-baneer-view'
import PreviewExpired from './preview-expired'

class PreviewBaneerContainer extends Component {

  stopPreview = () => {
    this.props.preview.disable()
  }

  render() {
    if (this.props.preview.isExpired()) return <PreviewExpired />
    if (!this.props.preview.isEnabled()) return null

    return (
      <PreviewBaneer message={this.props.preview.baneer.message} close={this.stopPreview} />
    )
  }

}

PreviewBaneerContainer.propTypes = {
  preview: PropTypes.object,
}

export default PreviewBaneerContainer
